import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./cookieConsent.css";

// Souhlas s měřením návštěvnosti (Google Consent Mode v2). Výchozí stav „odmítnuto“ nastavuje public/index.html
// ještě před načtením měřicího kódu; tady se jen ptáme a volbu předáváme dál.
// Lišta nic nepřekrývá ani neblokuje a robotům a předrenderu se nezobrazuje.
const KEY = "finpilot_consent";
const BOTS = /ReactSnap|HeadlessChrome|Lighthouse|bot|crawl|spider|slurp|GPTBot|ClaudeBot|PerplexityBot/i;
export const OPEN_EVENT = "finpilot:cookie-settings";

const read = () => {
  try { return window.localStorage.getItem(KEY); } catch (e) { return null; }
};

export default function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (BOTS.test(navigator.userAgent || "")) return undefined;
    const reopen = () => setOpen(true);
    window.addEventListener(OPEN_EVENT, reopen);
    // chvíli počkat, ať lišta nezdržuje první vykreslení stránky
    const timer = read() ? null : setTimeout(() => setOpen(true), 900);
    return () => {
      window.removeEventListener(OPEN_EVENT, reopen);
      if (timer) clearTimeout(timer);
    };
  }, []);

  const choose = useCallback((value) => {
    try { window.localStorage.setItem(KEY, value); } catch (e) { /* soukromé okno: volba platí jen pro tuto návštěvu */ }
    if (typeof window.gtag === "function") window.gtag("consent", "update", { analytics_storage: value });
    setOpen(false);
  }, []);

  if (!open) return null;
  return (
    <aside className="cookie-bar" role="region" aria-label="Souhlas s cookies">
      <p>
        Měříme návštěvnost, abychom web zlepšovali. Povolíte analytické cookies?{" "}
        <Link to="/cookies">Více</Link>
      </p>
      <div className="cookie-bar__actions">
        <button type="button" className="cookie-bar__btn" onClick={() => choose("denied")}>Odmítnout</button>
        <button type="button" className="cookie-bar__btn cookie-bar__btn--yes" onClick={() => choose("granted")}>Povolit</button>
      </div>
    </aside>
  );
}
